import {SelectionMenuController} from './selection-menu.controller';
import template from './selection-menu.template.html';

export const SelectionMenuComponent = {
    controller: SelectionMenuController,
    templateUrl: template,
    bindings: {
        items: '<',
        onItemSelected: '&'
    }
};



// WEBPACK FOOTER //
// ./src/js/components/selection-menu/selection-menu.component.js